import ClipboardJS from "../../../vendor/assets/javascripts/clipboard.min";

globalThis.Clipboard = ClipboardJS;
